import { DOMAIN } from '../utils/server'

export const DOMAIN_NAME = `https://www.${DOMAIN}.com`

export const HOME_PAGE = 'home'
export const NOT_FOUND_PAGE = '404'

export const BAND_PAGE = 'band'
export const SHOWS_PAGE = 'shows'
export const WRITINGS_PAGE = 'writings'
export const CONTACT_PAGE = 'contact'
export const LINKS_PAGE = 'links'

export const TABBED_PAGES_SET = new Set([])
